import { useTranslation } from 'react-i18next';

/**
 * Compatibility wrapper for next-intl's useTranslations.
 * Scopes the t() function to a namespace prefix so existing
 * call sites like t('key') continue to work as t('namespace.key').
 */
export function useTranslations(namespace?: string) {
  const { t } = useTranslation();
  if (!namespace) return t;
  return ((key: string, values?: Record<string, unknown>) =>
    t(`${namespace}.${key}`, values as any)) as typeof t;
}
